<template>
  <VList class="coupon-list">
    <VListItem class="coupon-list-item" v-for="coupon in coupons" :key="coupon.id">
      <VBlock
        :class="['coupon-title-area', selectedCoupon && coupon.id === selectedCoupon.id && 'coupon-active']"
        :padding="[15, 20, 0, 20]"
        :direction="Direction.column"
        :sort="Sort.left_center"
        :onClick="
          () => {
            isAvailable(coupon) && setCoupon(coupon)
          }
        "
      >
        <VBlock :margin="[0, 0, 4, 0]" :sort="Sort.left_center">
          <VImage
            :src="resources.bmartIcon"
            :width="40"
            :height="18"
            :style="{ opacity: isAvailable(coupon) ? '1' : '0.3' }"
          />
        </VBlock>
        <VBlock :sort="Sort.space_between" :margin="[0, 0, 4, 0]">
          <VSpan
            :style="{ opacity: isAvailable(coupon) ? '1' : '0.3' }"
            :text="coupon.amountText"
            :type="TextType.Number"
            :weight="TextWeight.bold"
            :size="26"
          />
          <VImage
            v-if="!selectedCoupon ? false : coupon.id === selectedCoupon.id"
            :src="resources.selectedIcon"
            :width="24"
            :height="24"
          />
        </VBlock>
        <VBlock :direction="Direction.row" :sort="Sort.left_center">
          <VP :style="{ opacity: isAvailable(coupon) ? '1' : '0.3' }" :text="coupon.name" :size="14" />
        </VBlock>
      </VBlock>

      <VBlock
        :class="['coupon-separate-area', selectedCoupon && coupon.id === selectedCoupon.id && 'coupon-active']"
        :padding="[0, 15]"
      >
        <div
          :class="['separate-area-circle', selectedCoupon && coupon.id === selectedCoupon.id && 'coupon-active']"
        ></div>
        <div class="separate-area-line"></div>
        <div
          :class="['separate-area-circle', selectedCoupon && coupon.id === selectedCoupon.id && 'coupon-active']"
        ></div>
      </VBlock>

      <VBlock
        :class="['coupon-notice-area', selectedCoupon && coupon.id === selectedCoupon.id && 'coupon-active']"
        :padding="[isIos ? 1 : 0, 20, 12, 20]"
        :sort="Sort.left_center"
        :direction="Direction.column"
      >
        <VBlock :sort="Sort.left_center" v-for="(message, idx) in coupon.unavailableMessages" :key="idx">
          <VSpan
            class="minimum-order-price"
            :text="message"
            :size="12"
            :color="TextColor.emergency"
            :type="TextType.Number"
          />
        </VBlock>
        <VSpan
          :style="{ opacity: isAvailable(coupon) ? '1' : '0.3' }"
          :text="`최소주문금액: ${coupon.minimumPurchaseAmount.toLocaleString()}원 · ${coupon.expirationText}`"
          :size="12"
          :color="TextColor.gray"
        />
      </VBlock>

      <!-- <VCard
        class="coupon"
        :class="{
          'coupon-active': !selectedCoupon ? false : coupon.id === selectedCoupon.id
        }"
        :color="!selectedCoupon ? ColorType.white : coupon.id === selectedCoupon.id ? ColorType.brand : ColorType.white"
        :radius="15"
      >
        <VBlock
          :onClick="
            () => {
              isAvailable(coupon) && setCoupon(coupon)
            }
          "
        >
          <VBlock :direction="Direction.column" :sort="Sort.left_center">
            <VSpan
              class="price"
              :style="{ opacity: isAvailable(coupon) ? '1' : '0.3' }"
              :text="coupon.amountText"
              :type="TextType.Number"
              :weight="TextWeight.bold"
              :size="26"
            />
            <VP
              class="description"
              :style="{ opacity: isAvailable(coupon) ? '1' : '0.3' }"
              :text="coupon.name"
              :size="18"
            />
            <VSpan
              :style="{ opacity: isAvailable(coupon) ? '1' : '0.3' }"
              class="end-count"
              :text="coupon.expirationText"
              :size="14"
              :color="TextColor.gray"
            />
            <VSpan
              v-if="isAvailable(coupon)"
              :style="{ opacity: isAvailable(coupon) ? '1' : '0.3' }"
              class="minimum-order-price"
              :text="`최소주문금액: ${coupon.minimumPurchaseAmount}원`"
              :size="14"
              :color="TextColor.gray"
              :type="TextType.Number"
            />
           
          </VBlock>
          <VImage
            v-if="!selectedCoupon ? false : coupon.id === selectedCoupon.id"
            :src="resources.selectedIcon"
            :width="24"
            :height="24"
          />
        </VBlock>
      </VCard> -->
    </VListItem>
  </VList>
</template>

<script>
import VSpan, { TextColor, TextWeight, TextType } from '@/presentationals/v2/components/layouts/atoms/VSpan'

import VImage from '@/presentationals/v2/components/layouts/atoms/VImage'
import VP from '@/presentationals/v2/components/layouts/atoms/VP'
import VBlock, { Sort, Direction } from '@/presentationals/v2/components/layouts/molecules/VBlock'
import { ButtonColor } from '@/presentationals/v2/components/layouts/atoms/VButton'
import VCard from '@/presentationals/v2/components/layouts/molecules/VCard'
import VList from '@/presentationals/v2/components/layouts/molecules/VList'
import VListItem from '@/presentationals/v2/components/layouts/molecules/VListItem'
import { ModalType, ColorType } from '@/presentationals/v2/components/layouts/molecules/VModal'
import { StockButtonType } from '@/presentationals/v2/components/layouts/atoms/VStockButton'

import selectedIcon from '@/assets/images/confirm-input-24.svg'
import bmartIcon from '@/assets/images/bmart-icon.svg'

export default {
  name: 'PreOrderCouponList',
  props: {
    onOK: {
      type: Function,
      required: true
    },
    onCancel: {
      type: Function
    },
    params: {
      type: Object,
      required: true
    },
    selectedCoupon: {
      type: Object
    },
    setCoupon: {
      type: Function
    },
    isAvailable: {
      type: Function
    },
    coupons: {
      type: Array
    }
  },
  components: {
    VP,
    VImage,
    VSpan,
    VBlock,
    VCard,
    VListItem,
    VList
  },
  computed: {
    isIos() {
      return this.$store.getters.isIos
    }
  },
  data() {
    return {
      ButtonColor,
      TextColor,
      TextWeight,
      TextType,
      Direction,
      Sort,
      ModalType,
      StockButtonType,
      ColorType,

      resources: {
        selectedIcon,
        bmartIcon
      },

      normalizeDatas: []
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/assets/scss/modules/colors';

.coupon-list {
  height: auto;
  box-sizing: border-box;

  .coupon-list-item {
    width: 100%;
    margin-bottom: 10px;

    .coupon-title-area {
      border-left: 1px solid $light-gray-6;
      border-top: 1px solid $light-gray-6;
      border-right: 1px solid $light-gray-6;
      border-top-left-radius: 8px;
      border-top-right-radius: 8px;
      background-color: $white;
      box-shadow: 0 1px 0 0 $light-gray-6;

      .description {
        width: calc(100% - 24px);
        word-break: break-all;
        white-space: pre-wrap;
        text-align: left;
        background-color: $white;
      }
    }

    .coupon-separate-area {
      position: relative;
      width: 100%;
      height: 20px;
      box-sizing: border-box;
      background-color: $white;
      overflow: hidden;

      & .separate-area-circle {
        position: absolute;
        z-index: 1;
        width: 20px !important;
        height: 20px;
        background-color: $background-gray;
        // border-radius: 10px;
        box-sizing: border-box;

        &:first-child {
          left: -10px;
          border-top-right-radius: 30px;
          border-bottom-right-radius: 30px;
          border: 1px solid $light-gray-6;
          border-left: 0;
        }

        &:last-child {
          right: -10px;
          border-top-left-radius: 30px;
          border-bottom-left-radius: 30px;
          border: 1px solid $light-gray-6;
          border-right: 0;
        }
      }

      & .separate-area-line {
        width: 100%;
        height: 1px;
        background-image: linear-gradient(to right, #d7d7d7 33%, rgba(255, 255, 255, 0) 0%);
        background-position: bottom;
        background-size: 6px 1px;
        background-repeat: repeat-x;
      }

      & .coupon-active {
        &:first-child {
          border: 1px solid $brand;
          border-left: 0;
        }

        &:last-child {
          border: 1px solid $brand;
          border-right: 0;
        }
      }
    }

    .coupon-notice-area {
      border-left: 1px solid $light-gray-6;
      border-bottom: 1px solid $light-gray-6;
      border-right: 1px solid $light-gray-6;
      border-bottom-left-radius: 8px;
      border-bottom-right-radius: 8px;
      background-color: $white;
      box-shadow: 0 1px 0 0 $light-gray-6;
    }

    & > .coupon-active {
      background-color: $brand-4;

      &:first-child {
        border-top: 1px solid $brand;
        border-left: 1px solid $brand;
        border-right: 1px solid $brand;
      }

      &:last-child {
        border-bottom: 1px solid $brand;
        border-left: 1px solid $brand;
        border-right: 1px solid $brand;
      }
    }
  }
}

.coupon-footer {
  width: 100%;
  height: 50px !important;
  // height: 126px !important;
  // height: 70px !important;
  box-sizing: border-box;
  padding: 0 10px;
  margin-bottom: 10px;
  margin-bottom: calc(constant(safe-area-inset-bottom) + 10px);
  margin-bottom: calc(env(safe-area-inset-bottom) + 10px);

  .coupon-apply-button {
    width: 100%;
    height: 50px !important;
    // box-sizing: border-box;
    // padding: 15px 0 15px 0;
  }
}
</style>
